import React from 'react';

const AddonToggle = () => {
  const [selected, setSelected] = React.useState('capacity');
  return (
    <div className='flex border border-primary-200 rounded-xl'>
      <div
        onClick={() => setSelected('capacity')}
        className={`text-gray-600 p-3 border-r rounded-s-xl  border-primary-200 font-medium flex items-center gap-2 text-base cursor-pointer ${selected === 'capacity' ? 'bg-primary-100 text-primary-1000' : ''}`}
      >
        Capacity
      </div>
      <div
        className={`text-gray-600 p-3 font-medium rounded-e-xl cursor-pointer flex items-center gap-2 text-base ${selected === 'messaging' ? 'bg-primary-100 text-primary-1000' : ''}`}
        onClick={() => setSelected('messaging')}
      >
        Messaging
      </div>
    </div>
  );
};

export default AddonToggle;
